import { useState, useEffect } from "react";

const MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function useMobileDetection(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof navigator !== "undefined") {
      return MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
    }
    return false;
  });

  useEffect(() => {
    setIsMobile(MOBILE_USER_AGENT_REGEX.test(navigator.userAgent));
  }, []);

  return isMobile;
}
